import { PopoverClickAwayClose } from './PopoverClickAwayClose';
import { PopoverDisplay } from './PopoverDisplay';
import { PopoverHoverEnter } from './PopoverHoverEnter';
import { PopoverHoverLeave } from './PopoverHoverLeave';
import { PopoverIsOpen } from './PopoverIsOpen';
import { PopoverOnClickClose } from './PopoverOnClickClose';
import { PopoverProvider } from './PopoverProvider';
import { PopoverToggle } from './PopoverToggle';

type PopoverCompound = typeof PopoverProvider & {
  Display: typeof PopoverDisplay;
  Toggle: typeof PopoverToggle;
  Enter: typeof PopoverHoverEnter;
  Leave: typeof PopoverHoverLeave;
  IsOpen: typeof PopoverIsOpen;
  OnClickClose: typeof PopoverOnClickClose;
  ClickAwayClose: typeof PopoverClickAwayClose;
};

/**
 * provides management of the anchor element and open/close state of the PopoverDisplay
 * requires a <<AnchorElement>> to consume event handler
 *
 * @example
 * ```jsx
 *   <Popover>
 *     <Popover.Toggle>
 *       <<AnchorElement>>
 *     </Popover.Toggle>
 *     <Popover.Display>
 *       ...
 *     </Popover.Display>
 *   </Popover>
 * ```
 */

export const Popover: PopoverCompound = Object.assign(PopoverProvider, {
  Display: PopoverDisplay,
  Toggle: PopoverToggle,
  Enter: PopoverHoverEnter,
  Leave: PopoverHoverLeave,
  IsOpen: PopoverIsOpen,
  OnClickClose: PopoverOnClickClose,
  ClickAwayClose: PopoverClickAwayClose,
});
